import React, {PureComponent} from 'react'
import PropTypes from 'prop-types'
import cx from 'classnames'

/* Config */
import appConfig from '../../../appConfig'

/* Actions */
import {actionCreators as featureToggleActionCreators} from '../../../redux/actions/featureToggleActions'

/* Utils */
import {stripHtmlTags} from '../../../common/html/htmlUtils'
import {generateQueryString} from '../../../common/url/urlUtils'
import KEY_CODES from '../../../common/dom/keyCodes'
import {resolveWithSettleContext} from '../../../common/async/promiseUtils'

/* Components */
import HbButton from '../../../components/HbButton/HbButton'
import Input from '../../../components/Input/Input'

/* Constants */
import {FEATURE_TOGGLE_NAMES} from '../../../modules/feature-toggle/featureToggleConstants'
import {DAVINCI_EVENT_NAMES} from '../../../modules/analytics/davinci/davinciConstants'
import {ONE_SECOND_MILISECOND} from '../../../common/time/timeConstants'

/* Styles */
import s from './not-found-page.scss'

const NOT_FOUND_FEATURE_TOGGLES = [
  FEATURE_TOGGLE_NAMES.ENABLE_GTM,
]

const imageUrl = 'https://images.hepsiburada.net/assets/sf/ErrorPageAssets/404-new@2x.png'

class NotFoundPage extends PureComponent {
  static propTypes = {
    className: PropTypes.string,
  }

  static async fetchData(dispatch) {
    let result

    const fetchOperationContext = {}

    const getFeatureTogglesResponse = await resolveWithSettleContext(dispatch(
      featureToggleActionCreators.getNotFoundPageFeatureToggles.trigger(
        NOT_FOUND_FEATURE_TOGGLES,
      ),
    ))

    if (getFeatureTogglesResponse?.result?.data?.data) {
      fetchOperationContext.featureToggles = getFeatureTogglesResponse.result?.data?.data
    }

    result = fetchOperationContext

    return result
  }

  constructor(props) {
    super(props)

    this.state = {
      keyword: '',
    }
  }

  componentDidMount() {
    window.addEventListener('load', this.handlePageLoadEvent, false)
  }

  componentWillUnmount() {
    window.removeEventListener('load', this.handlePageLoadEvent)
  }

  setKeyword(keyword) {
    this.setState(() => ({
      keyword: stripHtmlTags(keyword),
    }))
  }

  handleChange = (event) => {
    if (event && event.target) {
      this.setKeyword(event.target.value)
    }
  }

  handleButtonClick = () => {
    this.searchButtonSubmitLogic()
  }

  handlePageLoadEvent = () => {
    const timing = window.performance.timing

    setTimeout(() => {
      window?.hepsiBus?.track(DAVINCI_EVENT_NAMES.PAGE_LOAD, {
        domLoaded: (timing.domContentLoadedEventEnd - timing.navigationStart) / ONE_SECOND_MILISECOND,
        ready: (timing.loadEventEnd - timing.navigationStart) / ONE_SECOND_MILISECOND,
        experiments: [],
        isDynamic: false,
        page: '404ErrorPage',
      })
    }, 0)
  }

  handleLinkClickEvent = (event) => {
    window?.hepsiBus?.track(DAVINCI_EVENT_NAMES.LINK_CLICK, {
      text: event?.target?.textContent,
      url: event?.target?.getAttribute('href'),
      page_type: '404ErrorPage'
    })
  }

  handleKeyDown = (event) => {
    const {
      keyword,
    } = this.state

    if (event.keyCode === KEY_CODES.ENTER && keyword && keyword.length > 1) {
      this.searchButtonSubmitLogic()
    }
  }

  searchButtonSubmitLogic = () => {
    const {keyword} = this.state

    if (keyword.length > 1) {
      location.href = `${appConfig?.baseUrl}/ara${generateQueryString({
        q: keyword,
      },
      )}`
    }
  }


  render() {
    const {
      className,
    } = this.props

    const rootClassName = cx(
      s.root,
      className,
    )

    return (
      <div className={rootClassName}>
        <div className={s.header}>
          <a href='/' className={s.logo}/>
        </div>

        <div className={s.body}>
          <div className={s.mainContent}>
            <div className={s.textArea}>
              <h1 className={s.title}>
                {'Böyle bir sayfamız'}<br/>
                {'yok ama benzersiz fırsatlar'}<br id={'br'}/>
                {' burada!'}
              </h1>

              <p className={s.paragraph}>
                {'Sayfa kaldırılmış veya'}
                <br/> {'değiştirilmiş olabilir. Başka bir şey'}
                <br/> {'aramak ister misiniz?'}
              </p>

              <div className={s.searchArea}>
                <div className={s.searchInputArea}>
                  <div className={s.searchInputAreaInner}>
                    <i className={s.searchIcon}/>
                    <Input
                      value={this.state.keyword}
                      onChange={(e) => this.handleChange(e)}
                      onKeyDown={this.handleKeyDown}
                      otherClassName={s.searchText}
                      placeholder={'Milyonlarca ürün içinde ara'}
                      type='text'/>
                  </div>
                  <HbButton
                    onClick={this.handleButtonClick}
                    className={s.searchButton}
                    textClassName={s.searchButtonText}
                    text={'Ara'}/>
                </div>
              </div>

              <a
                className={s.homePageLink}
                onClick={this.handleLinkClickEvent}
                href='https://www.hepsiburada.com/'>
                {'Anasayfaya git'}
              </a>

            </div>

            <div className={s.imageContainer}>
              <img
                className={s.image}
                src={imageUrl}
                alt=''/>
            </div>
          </div>

          <div className={s.catagoryListContainer}>
            <h2 className={s.categoryListTitle}>
              {'Kategorilere göz at'}
            </h2>

            <ul className={s.categoryList}>
              <li className={s.categoryListItem}>
                <a
                  className={s.categoryListLink}
                  onClick={this.handleLinkClickEvent}
                  href='https://www.hepsiburada.com/bilgisayarlar-c-2147483646'>
                  {'Bilgisayar, Tablet'}
                </a>
              </li>
              <li className={s.categoryListItem}>
                <a
                  className={s.categoryListLink}
                  onClick={this.handleLinkClickEvent}
                  href='https://www.hepsiburada.com/telefonlar-c-2147483642'>
                  {'Telefon'}
                </a>
              </li>
              <li className={s.categoryListItem}>
                <a
                  className={s.categoryListLink}
                  onClick={this.handleLinkClickEvent}
                  href='https://www.hepsiburada.com/elektrikli-ev-aletleri-c-17071'>
                  {'Ev Elektroniği'}
                </a>
              </li>
              <li className={s.categoryListItem}>
                <a
                  className={s.categoryListLink}
                  onClick={this.handleLinkClickEvent}
                  href='https://www.hepsiburada.com/beyaz-esya-ankastreler-c-235604'>
                  {'Beyaz Eşya, Mutfak'}
                </a>
              </li>
              <li className={s.categoryListItem}>
                <a
                  className={s.categoryListLink}
                  onClick={this.handleLinkClickEvent}
                  href='https://www.hepsiburada.com/foto-kameralari-c-2147483606'>
                  {'Foto, Kamera'}
                </a>
              </li>
              <li className={s.categoryListItem}>
                <a
                  className={s.categoryListLink}
                  onClick={this.handleLinkClickEvent}
                  href='https://www.hepsiburada.com/spor-outdoor-urunleri-c-60001546'>
                  {'Spor Outdoor'}
                </a>
              </li>
              <li className={s.categoryListItem}>
                <a
                  className={s.categoryListLink}
                  onClick={this.handleLinkClickEvent}
                  href='https://www.hepsiburada.com/giyim-ayakkabi-c-2147483636'>
                  {'Giyim, Ayakkabı'}
                </a>
              </li>
              <li className={s.categoryListItem}>
                <a
                  className={s.categoryListLink}
                  onClick={this.handleLinkClickEvent}
                  href='https://www.hepsiburada.com/altin-taki-mucevherler-c-2147483617'>
                  {'Altın, Takı, Mücevher'}
                </a>
              </li>
              <li className={s.categoryListItem}>
                <a
                  className={s.categoryListLink}
                  onClick={this.handleLinkClickEvent}
                  href='https://www.hepsiburada.com/giyim-ayakkabi-c-2147483636'>
                  {'Saat, Gözlük, Aksesuar'}
                </a>
              </li>
              <li className={s.categoryListItem}>
                <a
                  className={s.categoryListLink}
                  onClick={this.handleLinkClickEvent}
                  href='https://www.hepsiburada.com/kozmetik-kisisel-bakim-urunleri-c-60001547'>
                  {'Kozmetik, Kişisel Bakım'}
                </a>
              </li>
              <li className={s.categoryListItem}>
                <a
                  className={s.categoryListLink}
                  onClick={this.handleLinkClickEvent}
                  href='https://www.hepsiburada.com/anne-bebek-oyuncak-c-2147483639'>
                  {'Anne, Bebek, Oyuncak'}
                </a>
              </li>
              <li className={s.categoryListItem}>
                <a
                  className={s.categoryListLink}
                  onClick={this.handleLinkClickEvent}
                  href='https://www.hepsiburada.com/kitaplar-filmler-muzikler-c-60001501'>
                  {'Kitap, Film, Müzik'}
                </a>
              </li>
              <li className={s.categoryListItem}>
                <a
                  className={s.categoryListLink}
                  onClick={this.handleLinkClickEvent}
                  href='https://www.hepsiburada.com/hobi-oyun-konsollari-c-60003054'>
                  {'Hobi ve Oyun Konsolları'}
                </a>
              </li>
              <li className={s.categoryListItem}>
                <a
                  className={s.categoryListLink}
                  onClick={this.handleLinkClickEvent}
                  href='https://www.hepsiburada.com/yapi-market-bahce-oto-c-60002705'>
                  {'Yapı Market, Bahçe, Oto'}
                </a>
              </li>
              <li className={s.categoryListItem}>
                <a
                  className={s.categoryListLink}
                  onClick={this.handleLinkClickEvent}
                  href='https://www.hepsiburada.com/ev-dekorasyon-c-60002028'>
                  {'Eb Dekorasyon'}
                </a>
              </li>
              <li className={s.categoryListItem}>
                <a
                  className={s.categoryListLink}
                  onClick={this.handleLinkClickEvent}
                  href='https://www.hepsiburada.com/pet-shop-c-2147483616'>
                  {'Petshop'}
                </a>
              </li>
              <li className={s.categoryListItem}>
                <a
                  className={s.categoryListLink}
                  onClick={this.handleLinkClickEvent}
                  href='https://www.hepsiburada.com/supermarket-c-2147483619'>
                  {'Süpermarket'}
                </a>
              </li>
              <li className={s.categoryListItem}>
                <a
                  className={s.categoryListLink}
                  onClick={this.handleLinkClickEvent}
                  href='https://www.hepsiburada.com/akilli-ev-yasam-c-80079038'>
                  {'Akıllı Ev & Yaşam'}
                </a>
              </li>
            </ul>
          </div>
        </div>
      </div>
    )
  }
}


export default NotFoundPage
